import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import confetti from 'canvas-confetti';
import { useEffect } from 'react';
import { vibrate, HAPTICS } from '../utils/haptics';
import Bongo from './Bongo';

const LevelUpCelebration = ({ newLevel, levelName, t, onClose }) => {
  useEffect(() => {
    vibrate(HAPTICS.SUCCESS);
    // Fire confetti
    const colors = ['#E8A87C', '#D4A5A5', '#B5C99A', '#A8D8EA', '#FFB6C1'];
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors,
      disableForReducedMotion: true
    });
    const burstTimer = setTimeout(() => {
      confetti({ particleCount: 50, angle: 60, spread: 55, origin: { x: 0 }, colors });
      confetti({ particleCount: 50, angle: 120, spread: 55, origin: { x: 1 }, colors });
    }, 250);
    return () => clearTimeout(burstTimer);
  }, []);

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center"
        onClick={onClose}
        data-testid="level-up-celebration"
      >
        <motion.div
          initial={{ scale: 0, rotate: -10 }}
          animate={{ scale: 1, rotate: 0 }}
          exit={{ scale: 0, rotate: 10 }}
          transition={{ type: 'spring', damping: 15, stiffness: 200 }}
          className="bg-white rounded-3xl p-8 shadow-2xl text-center max-w-sm mx-4"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="mb-4 flex justify-center">
            <Bongo mood="happy" size="large" />
          </div>

          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-2xl font-bold text-[color:var(--cb-text)] mb-2"
          >
            {t('levelUp')}
          </motion.h2>

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.4, type: 'spring' }}
            className="text-5xl font-bold text-[color:var(--cb-primary)] mb-2"
          >
            {newLevel}
          </motion.div>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-[color:var(--cb-accent-1)] font-medium text-lg"
          >
            {levelName}
          </motion.p>

          <motion.button
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.7 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClose}
            className="mt-6 px-8 py-3 bg-[color:var(--cb-primary)] text-white rounded-full font-semibold shadow-[0_10px_24px_rgba(232,168,124,0.35)]"
          >
            {t('amazing')}!
          </motion.button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default LevelUpCelebration;
